// extracted by mini-css-extract-plugin
module.exports = {"FilterBoxLabel":"FilterBox_FilterBoxLabel__tWG30","Panel":"FilterBox_Panel__CFNGN"};